import { Component, OnInit } from "@angular/core";
// Services
import { ElasticService } from "./../../services/elastic";
// External
import * as lodash from "lodash";
import { Club } from "./../../models/club";

import { ApiService } from "./../../services/api";

@Component({
  selector: "app-confirm-clubs",
  templateUrl: "./confirm.club.component.html",
})
export class ConfirmClubComponent implements OnInit {
  public selectAll: boolean;
  public filterargs: Club;

  public currentPage: number;
  public maxPage: number;
  public showVerified: boolean;
  public clubs: Array<any>;
  public imageLoader: boolean = true;
  public query: string;
  //  public trialList: Array<any>;
  public typingDelay: any;
  public pageSize: number;
  public trialDays = 7;
  private selectedClub: any;
  constructor(
    private elasticService: ElasticService,
    private apiService: ApiService
  ) {
    this.currentPage = 0;
    this.pageSize = 30;
    this.showVerified = false;
    this.query = "";
    this.selectAll = false;
  }

  ngOnInit() {
    // this.trialList = [];
    // this.trialList.push({ name: "7 trial days", days: 7 }, { name: "15 trial days", days: 15 }, { name: "30 trial days", days: 30 });
    this.imageLoader = false;
    this.filterargs = new Club();

    this.goToPage(this.currentPage);
  }

  showChange(isVerified: boolean) {
    this.showVerified = isVerified;
    this.goToPage(0);
  }

  goToPage(index: number) {
    const fromIndex = index * this.pageSize;

    let queryParams = {
      index: "users",
      type: "club",
      size: this.pageSize,
      from: fromIndex,
      "body/query/match_phrase_prefix/isVerified": `false`,
    };
    console.log(queryParams);

    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.clubs = [];
        console.log(result);
        lodash.forEach(result["hits"], (item) => {
          if (item) {
            if (item["_source"]["name"])
              this.clubs.push(
                lodash.assign({ $key: item["_id"] }, item["_source"])
              );
          }
        });
        lodash.forEach(this.clubs, (item, key) => {
          // console.log(item)
          item.isSelected = false;
        });
        window.scrollTo(0, 0);

        this.currentPage = index;
        this.maxPage = Math.ceil(result["total"] / this.pageSize);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  public clubSelect(event, club) {
    if (event) {
      club.isSelected = true;
      var i = -1;
      for (i = 0; i < this.clubs.length; i++) {
        if (this.clubs[i].isSelected == false) {
          break;
        }
      }
      if (i != -1 && i != this.clubs.length) {
        this.selectAll = false;
      } else {
        this.selectAll = true;
      }
    } else {
      club.isSelected = false;
      this.selectAll = false;
    }
    // console.log(event)
    // console.log(club)
  }
  public selectAllClub(event) {
    if (event) {
      lodash.forEach(this.clubs, (item, key) => {
        // console.log(item)
        item.isSelected = true;
      });
    } else {
      lodash.forEach(this.clubs, (item, key) => {
        // console.log(item)
        item.isSelected = false;
      });
    }
  }
  public confirmAll() {
    if (confirm("Are you sure?")) {
      lodash.forEach(this.clubs, (item, key) => {
        // console.log(item)
        if (item.isSelected) {
          // console.log(item.$key)
          let trial = new Date();
          trial.setMonth(trial.getMonth() + 1);

          this.apiService
            .update(`/users/${item.$key}`, {
              isVerified: true,
              updatedAt: new Date().getTime() / 1000,
              registerDate: new Date().getTime(),
              trial: trial.getTime() / 1000,
              trialDays: 30,
            })
            .then(() => {
              // const clubIndex = this.clubs.indexOf(item);
              // this.clubs.splice(clubIndex, 1);
              this.goToPage(this.currentPage);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
    }
  }
  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }

  getIndex(index: number) {
    return this.currentPage * this.pageSize + index + 1;
  }
  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.goToPage(this.currentPage);
    }, 400);
  }

  openModal(club) {
    this.selectedClub = club;
    $("#myModal").modal("show");
  }
  confirmClub() {
    const club = this.selectedClub;
    let trial = new Date();

    trial.setDate(trial.getDate() + this.trialDays);
    // console.log(trial)
    if (confirm("Are you sure? you want to confirm this club")) {
      this.apiService
        .update(`/users/${club.$key}`, {
          trial: trial.getTime() / 1000,
          status: 1,
          isVerified: true,
          updatedAt: new Date().getTime() / 1000,
          trialDays: this.trialDays,
        })
        .then(async () => {
          await this.apiService.set(
            "user-profiles/" + club.uid + "/" + club.$key,
            {
              role: 1,
              type: 1,
              isVerified: true,
            }
          );
          location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  reset(club) {
    console.log(club);
    if (confirm("Are you sure? you want to Suspend and reset this club")) {
      this.apiService
        .update(`/users/${club.$key}`, {
          isVerified: null,
          updatedAt: new Date().getTime() / 1000,
          registerDate: null,
          uid: null,
          email: null,

          phone: null,
        })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
